import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { KYMW4500Component } from './kymw4500.component';
import { PlessSharedModule } from '../../../shared/pless-shared.module';
import { KYMW4501Module } from '../kymw4501/kymw4501.module';
import { KYMW4502Module } from '../kymw4502/kymw4502.module';
import { WjNavModule } from '@grapecity/wijmo.angular2.nav';
import { WjGridModule } from '@grapecity/wijmo.angular2.grid';
import { AppCommonsModule } from '../../../commons/app-commons.module';
import { GetFeatureMasterInfoService } from './api-services/get-feature-master-info.service';
import { GetCatalogFixFlagService } from './api-services/get-catalog-fix-flag.service';
import { GetApprovalFlowListService } from './api-services/get-approval-flow-list.service';
import { GetFixFeatureForMasterInfoService } from './api-services/get-fix-feature-for-master-info.service';
import { GetNotificationUserListService } from './api-services/get-notification-user-list.service';
import { UpdateFeatureMasterInfoService } from './api-services/update-feature-master.service';
import { GetMediumGroupDivService } from './api-services/get-medium-group-div.service';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { KYMW0400Module } from 'src/app/commons/kymw04/kymw0400/kymw0400.module';
import { KYMW0003Module } from 'src/app/commons/kymw00/kymw0003/kymw0003.module';

/**
 * 特集マスタ画面 モジュール設定クラス
 *
 * @export KYMW4500Module
 * @class KYMW4500Module
 */
@NgModule({
  imports: [
    CommonModule,
    FormsModule,    
    PlessSharedModule,
    KYMW4501Module,
    KYMW4502Module,
    KYMW0400Module,
    KYMW0003Module,
    WjNavModule,
    WjGridModule,
    AppCommonsModule,
    FontAwesomeModule
  ],
  declarations: [
    KYMW4500Component,
  ],
  providers: [
    GetFeatureMasterInfoService,
    GetCatalogFixFlagService,
    GetApprovalFlowListService,
    GetFixFeatureForMasterInfoService,
    GetNotificationUserListService,
    UpdateFeatureMasterInfoService,
    GetMediumGroupDivService,
  ],
})
export class KYMW4500Module { }
